module.exports = __webpack_public_path__ + "static/fonts/iconfont.6398ea8.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_custom/iconfont.eot?t=1566030762759
// module id = 460
// module chunks = 99